import { Link } from "react-router-dom";
import { ShoppingCart, Check } from "lucide-react";
import { fmtPrice } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Stars } from "@/components/Stars";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const isPackage = product.badge === "PACHET" || /x/i.test(product.volume || "");

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product);
  };

  return (
    <Link
      to={`/produs/${product.slug}`}
      className="bg-white border-2 border-slate-100 rounded-2xl p-6 shadow-xl shadow-black/5 flex flex-col hover:border-eco/30 hover:-translate-y-1 transition-all duration-300"
      data-testid={`product-card-${product.slug}`}
    >
      {isPackage ? (
        <>
          <div className="relative rounded-xl overflow-hidden bg-slate-50 mb-4">
            {product.badge && (
              <span className="absolute top-2 left-2 z-10 bg-red-600 text-white text-[10px] font-extrabold px-2 py-0.5 rounded">
                {product.badge}
              </span>
            )}
            <img src={product.image} alt={product.name} className="w-full h-56 object-contain" />
          </div>
          <h3 className="font-display font-black text-navy text-xl tracking-tight">{product.name}</h3>
          {product.review_count > 0 && (
            <div className="mb-1"><Stars value={product.avg_rating} count={product.review_count} /></div>
          )}
          <p className="text-sm text-muted-foreground mb-3">{product.description}</p>
          <ul className="space-y-1.5">
            {product.features.map((f) => (
              <li key={f} className="flex items-center gap-2 text-sm text-slate-700">
                <Check className="h-4 w-4 text-eco shrink-0" /> {f}
              </li>
            ))}
          </ul>
        </>
      ) : (
        <div className="flex gap-4">
          <div className="relative shrink-0">
            {product.badge && (
              <span className="absolute -top-2 -left-2 z-10 bg-red-600 text-white text-[9px] font-extrabold px-2 py-0.5 rounded">
                {product.badge}
              </span>
            )}
            <img src={product.image} alt={product.name} className="h-36 w-28 object-contain" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-display font-black text-navy text-xl tracking-tight">{product.name}</h3>
          {product.review_count > 0 && (
            <div className="mb-1"><Stars value={product.avg_rating} count={product.review_count} /></div>
          )}
            <p className="text-sm text-muted-foreground mb-3">{product.description}</p>
            <ul className="space-y-1.5">
              {product.features.map((f) => (
                <li key={f} className="flex items-center gap-2 text-sm text-slate-700">
                  <Check className="h-4 w-4 text-eco shrink-0" /> {f}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      <div className="mt-auto pt-5">
        <div className="flex items-baseline gap-2 mb-3">
          {product.old_price && (
            <span className="text-sm text-slate-400 line-through">{fmtPrice(product.old_price)} lei</span>
          )}
          <span className="font-display font-black text-navy text-3xl">{fmtPrice(product.price)}</span>
          <span className="font-display font-bold text-navy text-sm">LEI</span>
          <span className="text-xs text-muted-foreground ml-auto">/ {product.volume}</span>
        </div>
        <button
          onClick={handleAdd}
          className="w-full bg-eco hover:bg-green-700 text-white font-display font-bold py-3 rounded-xl flex items-center justify-center gap-2 transition-colors active:scale-[0.98]"
          data-testid={`add-to-cart-${product.slug}`}
        >
          <ShoppingCart className="h-5 w-5" /> ADAUGĂ ÎN COȘ
        </button>
      </div>
    </Link>
  );
};
